'use client';

import type { ReactNode } from 'react';
import { useDebugMode } from '../../hooks/useDebugMode/useDebugMode';

export const OnlyInDebugMode = ({ children }: { children: ReactNode }) => {
  const { debugModeActive } = useDebugMode();

  if (!debugModeActive) return null;

  return children;
};
